import { AnyAction } from 'redux';
import apiTypes from 'src/api/optimalprint-sdk.d';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { ThunkDispatch } from 'redux-thunk';
import { UploadedImageData } from 'src/store/gallery/types';
import { Store } from 'src/store/index';

const sendGalleryUploadedImagesPostMessageOperation = (images: apiTypes.AppBundle.Api.Entity.Photo.V1.IPhoto[]) => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
) => {
  const imagesToSend = images.map((image) => {
    const photo = image;

    const data: UploadedImageData = {
      url: photo.url || '',
      file: {
        id: photo.sourcePictureId || '',
        name: photo.n || '',
        type: 'image',
        width: photo.ow,
        height: photo.oh,
      },
    };

    // Embroidery: pass quantized data so editor knows the image is already quantized.
    // Mirrors dashboard's uploaded-image-data.service which maps asset.preview_quantized
    // and asset.metadata.quantizedColors to the gallery image.
    if (photo.quantizedUrl) {
      data.quantizedUrl = photo.quantizedUrl;
    }
    if (photo.quantizedColors) {
      data.file.quantizedColors = photo.quantizedColors;
    }

    return data;
  });

  if (!imagesToSend.length) {
    return;
  }

  sendPostMessage({
    type: MESSAGE_TYPE['gallery.loadUploadedImages'],
    data: imagesToSend,
  });
};

export default sendGalleryUploadedImagesPostMessageOperation;
